(function ($) {
    $.atacTable = function (element, options) {
        var defaults = {

        }

        var plugin = this;
        plugin.settings = {}

        var $element = $(element), // reference to the jQuery version of DOM element
             element = element;    // reference to the actual DOM element

        plugin.init = function () {
            plugin.settings = $.extend({}, defaults, options);
            setupFilterable();
        }

        var setupFilterable = function () {
            var filterObj = {};

            if (!plugin.settings.tableFilterable)
                return;

            var filterFired = function () {

                $element.find("tbody tr").each(function () {
                    var $row = $(this);
                    var passed = _.every(filterObj, function (o, key) {
                        var $cell = $($row.find("td,th")[o.index]);
                        var val = $cell.text();

                        switch (o.type) {
                            default:
                                if (val.search(o.value) === -1)
                                    return false;
                                break;
                        }

                        return true;
                    });

                    if (passed) {
                        $row.show();
                    } else {
                        $row.hide();
                    }
                });
            };

            var setupFilter = function ($th, index) {

                var data_in = $th.data();
                var data_out = {
                    type: data_in.filterType,
                    value: null,
                    index: index
                };


                var $td = $("<td>");
                var $filter = null;

                if (!data_in.filterType)
                    return $td;

                switch (data_in.filterType) {
                    case "string":

                        $filter = $("<input>").attr('type', 'text').bind("keyup", function () {
                            data_out.value = $(this).val();
                            $(this).trigger('filterUpdate', data_out);
                        }).addClass('form-control');

                        break;
                    case "select":
                        $filter = $("<select>").bind('change', function () {
                            data_out.value = $(this).val();
                            $(this).trigger('filterUpdate', data_out);
                        }).addClass('form-control');;

                        var vals = _.uniq(_.map($element.find("tbody tr"), function (e) { return $($(e).find("th,td")[index]).text() }));
                        //we need to get all the unique values out...
                        //default option
                        $filter.append($("<option>").attr('text', '').attr('value', '').html('Select'));

                        _.each(vals, function (v) {
                            $filter.append($("<option>").attr('text', v).attr('value', v).html(v));
                        });

                        break;
                    case "int":
                        $filter = $("<input>").attr('type', 'number').bind("keyup", function () {
                            data_out.value = $(this).val();
                            $(this).trigger('filterUpdate', data_out);
                        }).addClass('form-control');;
                        break;
                }

                if ($filter) {
                    var $div = $("<div>").addClass('filter-holder');
                    $div.append($filter);
                    $td.append($div);
                    $filter.bind('filterUpdate', _.debounce(function (e, x) {
                        filterObj[x.index] = x;
                        filterFired();
                    }, 500));
                }

                return $td;
            };

            var addFilters = function () {

                var $filterHead = $("<tr>").addClass('filter-row').attr('role', 'menu').attr('id', plugin.settings.tableFilterId);

                $element.find("thead th").each(function (i) {
                    var $th = $(this);
                    var $td = setupFilter($th, i);

                    $filterHead.append($td);
                });

                $element.find("thead").append($filterHead);
            };
            addFilters();
        };


        plugin.init();
    }

    $.fn.atacTable = function (options) {
        return this.each(function () {
            if (undefined == $(this).data('atacTable')) {
                var plugin = new $.atacTable(this, options);
                $(this).data('atacTable', plugin);
            }
        });
    }
})(jQuery);


(function () {
    $("table.atac-table").each(function () {
        var $el = $(this);
        $el.atacTable($el.data());
    });
})();









